export const SET_SOURCE_WEB_PAGE = "@ONBOARDING/SET_SOURCE_WEB_PAGE";
